import { render, staticRenderFns } from "./chateau-ducru-beaucaillou.vue?vue&type=template&id=34e8f747&scoped=true"
import script from "./chateau-ducru-beaucaillou.vue?vue&type=script&lang=js"
export * from "./chateau-ducru-beaucaillou.vue?vue&type=script&lang=js"
import style0 from "./chateau-ducru-beaucaillou.vue?vue&type=style&index=0&id=34e8f747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8f747",
  null
  
)

export default component.exports